import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Container, Dropdown, Image, Segment } from 'semantic-ui-react'

import defaultAvatar from '../../assets/images/default-avatar.png'
import logo from '../../assets/images/logo.png'
import { logOut as out } from '../../helpers/auth'
import { defaultLanguage, getLanguage, setLanguage, tr } from '../../helpers/languages'
import { actions as misc } from '../../store/actions/misc'
import { actions as settings } from '../../store/actions/settings'
import { send } from '../../helpers/requests'
import { actions as messages } from '../../store/actions/messages'
import { actions as profiles } from '../../store/actions/profiles'
import cookie from 'react-cookies'
import LogoutConfirmation from '../logout-confirmation'
import config from '../../config'

class Navbar extends Component {
    constructor (props) {
        super(props)
        this.state = {
            isBeaconOpen: false
        }
        autoBind(this)
    }

    showLogoutConfirmation () {
        this.setState({ loggingOut: true })
    }

    // Logs out the logged-in therapist.
    logOut () {
        localStorage.removeItem('sidebarScroll')
        // Wipe everything out.
        this.props.wipeOut()
        // Log the therapist out.
        // NOTE: Even if logout fails, there is nothing we want to do about it.
        out()
    }

    cancelLogOut () {
        this.setState({ loggingOut: false })
        // close()
    }

    changeLang (language) {
        setLanguage(language)
        this.updateTherapist(language)
    }

    // Updates the therapist's language.
    updateTherapist (language) {
        // eslint-disable-next-line no-console
        console.log('Update therapist\'s language.')
        const profile = {
            language: language
        }
        send({
            method: 'PUT',
            tokens: this.props.userTokens,
            url: '/therapist',
            data: profile
        })
            .then((_response) => {
                // eslint-disable-next-line no-console
                console.log('Updated therapist\'s language.')
                this.setState({ doNotDisturb: false })
                this.props.setProfile(profile)
                this.fetchTherapist()
            })
            .catch((error) => {
                // Failed to fetch therapist.
                // eslint-disable-next-line no-console
                console.error('Failed to update therapist\'s language.', error)
                this.setState({ doNotDisturb: false })
                this.props.message({ type: 'error', text: tr('FAILED_TO_SAVE_CHANGES') })
            })
    }

    // Fetches the therapist's profile.
    fetchTherapist () {
        // eslint-disable-next-line no-console
        console.log('Fetch therapist.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: '/therapist'
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched therapist.')
                const data = response.data
                const language = data.language || defaultLanguage
                const profile = {
                    language,
                }
                this.setState({
                    language: profile.language,
                })
                this.props.setProfile(profile)
                this.props.setLanguage(language)
                cookie.save('language', language)
                window.location.reload()
            })
            .catch((error) => {
                // Failed to fetch therapist.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch therapist.', error)
                // Hide the error.
            })

    }

    initBeacon () {
        if (this.state.isBeaconOpen) {
            this.setState({ isBeaconOpen: false }, this.closeBeacon)
        } else {
            this.setState({ isBeaconOpen: true }, this.openBeacon)
        }
    }

    openBeacon () {
        window.Beacon('init', config.beaconToken)
        window.Beacon('toggle')
        window.Beacon('navigate', '/ask/')
    }

    closeBeacon () {
        window.Beacon('toggle')
        window.Beacon('destroy')
    }

    render () {
        return (
            <Container className='navbar'>
                <Segment>
                    <Link to='/'>
                        <Image className='logo' src={logo}/>
                    </Link>
                    <Link to='/profile'>
                        <Image src={this.props.picture ? this.props.picture : defaultAvatar} size='tiny' circular/>
                    </Link>
                    <div role='link' tabIndex={0} className='link lang'>
                        <Dropdown
                            className={'language-selection'}
                            fluid
                            selection
                            icon='angle down'
                            options={
                                [
                                    {
                                        value: 'en',
                                        text: 'EN'
                                    },
                                    {
                                        value: 'de',
                                        text: 'DE'
                                    }
                                ]
                            }
                            value={getLanguage()}
                            onChange={(_e, { value }) => {this.changeLang(value)}}
                        />
                    </div>
                    <div role='link' tabIndex={0} className='link' onClick={(_e) => { this.showLogoutConfirmation() }}>
                        {tr('LOG_OUT')}
                    </div>

                    {
                        this.state.loggingOut &&
                        <LogoutConfirmation
                            onSaveChanges={this.logOut}
                            onCancelChanges={this.cancelLogOut}
                            onClose={this.cancelLogOut}
                        />
                    }

                    <div className='link'>
                        <a style={{ color: 'inherit' }}
                           onClick={this.initBeacon}
                        >
                            {tr('HELP')}</a>
                    </div>

                    <div className='link'>
                        <a style={{ color: 'inherit' }}
                           target="_blank"
                           href={getLanguage() === 'en' ? 'https://policies.myfeel.co/en/privacy-notice' : 'https://policies.myfeel.co/de/privacy-notice'}>{tr('PRIVACY_NOTICE')}</a>
                    </div>

                    <div className='link'>
                        <a style={{ color: 'inherit' }}
                           target="_blank"
                           href={'https://secure.helpscout.net/members/login/'}>{tr('HELPSCOUT')}</a>
                    </div>

                    <Link to='/dashboard'>
                        <div className='link'>
                            {tr('HOME')}
                        </div>
                    </Link>
                </Segment>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        picture: state.profiles.profile.picture,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    const _misc = bindActionCreators(misc, dispatch)
    const _settings = bindActionCreators(settings, dispatch)
    const _profiles = bindActionCreators(profiles, dispatch)
    return {
        setLanguage: _settings.setLanguage,
        setTimezone: _settings.setTimezone,
        wipeOut: _misc.wipeOut,
        message: _messages.message,
        setProfile: _profiles.setProfile,
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar))



// WEBPACK FOOTER //
// ./src/components/navbar/index.js